export default "__VITE_ASSET__CP9Z4C5L__"